import { render, staticRenderFns } from "./CommentNotification.vue?vue&type=template&id=5c9ee386"
import script from "./CommentNotification.vue?vue&type=script&lang=ts"
export * from "./CommentNotification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports